module.exports = __webpack_public_path__ + "img/createFolder.c2e0047a.svg";